<template>
  <div class="page-publicDetail">
    <div class="d-title" v-html="publicDetail.infoTitle">
      <!-- {{ publicDetail.infoTitle }} -->
    </div>
    <div class="d-source-time">
      <div>时间：{{ publicDetail.publishTime }}</div>
      <div>来源：{{ publicDetail.infoSource }}</div>
    </div>
    <div class="d-introduce" v-if="publicDetail.infoIntroduce">
      <h3>导语：</h3>
      <p>{{ publicDetail.infoIntroduce }}</p>
    </div>
    <!-- <div class="d-img" v-if="publicDetail.infoImg">
      <img :src="publicDetail.infoImg" alt="photo" @error="infoImgError" />
    </div> -->
    <div class="d-content" v-html="publicDetail.infoContent"></div>
    <div class="d-file" v-if="publicDetail.enclosure.length > 0">
      <div class="d-file-title">附件</div>
      <div
        class="d-file-files"
        v-for="(item, index) in publicDetail.enclosure"
        :key="item.name + index"
      >
        <a :href="item.downUrl" target="_blank">
          {{ `${index + 1}.${item.name}` }}
        </a>
      </div>
    </div>
    <div
      class="d-prev-next"
      v-if="
        Object.keys(prevData).length > 0 || Object.keys(nextData).length > 0
      "
    >
      <div v-if="Object.keys(prevData).length > 0">
        <span>上一篇</span>
        <span @click="toPrevOrNext(prevData.id)">
          {{ prevData.infoName }}
        </span>
      </div>
      <div v-if="Object.keys(nextData).length > 0">
        <span>下一篇</span>
        <span @click="toPrevOrNext(nextData.id)">
          {{ nextData.infoName }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '../../api/home/index'
import { classList } from '../publicInformationList/assets'
export default {
  name: 'PublicInformationDetailMobile',
  data() {
    const { classifyId = 1, id } = this.$route.query
    const { label, iconName } =
      classList.find((item) => item.value === Number(classifyId)) ?? {}
    return {
      id,
      classifyId,
      classList,
      list: [
        {
          label,
          path: '/publicInformationList',
          query: { classifyId }
        },
        {
          label: `${label}详情`,
          path: '/publicInformationDetail'
        }
      ],
      classifyName: label,
      classifyIcon: require(`../../assets/image/${iconName}`),
      publicDetail: { enclosure: [] },
      prevData: {},
      nextData: {}
    }
  },
  created() {
    document.body.style.minWidth = '100vw'
    this.defaultInit()
  },
  methods: {
    // 默认进入
    defaultInit() {
      this.getPublicDetail()
      this.getPublicList()
    },
    async getPublicDetail(resolveC = () => {}, rejectC = () => {}) {
      const { id } = this
      if (!id) return
      try {
        const res = await API.getDetailPublic({ id: this.id })
        const { code, data = {} } = res
        if (code === 0) {
          this.publicDetail = {
            ...data,
            enclosure: JSON.parse(data.enclosure)
          }
          resolveC(true)
        } else {
          throw Error()
        }
      } catch (error) {
        rejectC(false)
      }
    },
    async getPublicList() {
      const { classifyId, id: _thisId } = this
      if (!(classifyId && _thisId)) return
      try {
        const params = {
          page: 1,
          limit: -1,
          classifyId
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          for (let i = 0; i < records.length; i++) {
            const { id } = records[i]
            if (id === _thisId) {
              if (i !== 0) {
                this.prevData = {
                  id: records[i - 1]?.id,
                  infoName: records[i - 1]?.infoName
                }
              } else {
                this.prevData = {}
              }
              if (i !== records.length - 1) {
                this.nextData = {
                  id: records[i + 1]?.id,
                  infoName: records[i + 1]?.infoName
                }
              } else {
                this.nextData = {}
              }
              break
            }
          }
        }
      } catch (error) {}
    },
    toPrevOrNext(id) {
      this.id = id
      const { classifyId } = this
      window.history.replaceState(
        { classifyId, id },
        '',
        `?classifyId=${classifyId}&id=${id}&hideHeader=true&hideFooter=true`
      )
      this.getPublicDetail()
      this.getPublicList()
    },
    infoImgError() {
      this.$set(this.publicDetail, 'infoImg', null)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-publicDetail {
  min-height: 100vh;
  background: #eef3ff;

  .d-title {
    // font-family: Microsoft YaHei;
    // font-weight: bold;
    // color: #0853b6;
    text-align: center;
    // line-height: 80px;
  }
  .d-source-time {
    background: rgba($color: #000000, $alpha: 0.1);
    padding: 20px 10px;
    margin: 0 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  .d-introduce {
    background: #f2f2f2;
    margin: 20px;
    padding: 20px 10px;
    > h3 {
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      margin-bottom: 20px;
    }
    > p {
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
    }
  }
  .d-img {
    margin: 0 20px 30px;
    text-align: center;
    img {
      max-width: 100%;
    }
  }
  .d-content {
    margin: 0 20px 30px;
  }
  .d-file {
    margin: 0 20px 50px;
    .d-file-title {
      font-family: Microsoft YaHei;
      font-weight: bold;
      text-decoration: underline;
      color: #333333;
      margin-bottom: 10px;
    }
    .d-file-files {
      margin-bottom: 10px;
      > a {
        font-family: Microsoft YaHei;
        font-weight: bold;
        text-decoration: underline;
        color: #0e2cf8;
        cursor: pointer;
      }
    }
  }
  .d-prev-next {
    background: #f2f2f2;
    margin: 0 20px;
    box-sizing: border-box;
    padding: 20px;
    > div {
      > span:first-child {
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin-right: 30px;
      }
      > span:last-child {
        font-family: Microsoft YaHei;
        font-weight: 600;
        color: #0853b6;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang='scss'>
.d-content * {
  max-width: 100%;
}
</style>
